import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Store } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-300 pt-16 pb-8 border-t-4 border-primary mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-7 gap-x-6 gap-y-10 mb-12">
          <div className="sm:col-span-2 lg:col-span-3 xl:col-span-2">
            <Link
              to="/"
              className="inline-block mb-6 w-[200px] md:w-[250px]"
              aria-label="Home"
            >
              <img
                loading="lazy"
                decoding="async"
                src="https://vibe.filesafe.space/1781862609113466713/attachments/c36d85c1-49ed-4cf3-9e8d-89006f7035ac.png"
                alt="Logo Rijschool De Diamant Alphen aan den Rijn"
                width={250}
                height={58}
                className="w-full h-auto object-contain drop-shadow-xl transition-transform duration-300 scale-95 md:scale-100"
              />
            </Link>
            <p className="text-slate-400 mb-6 leading-relaxed">
              Dé rijschool in Alphen aan den Rijn en omgeving. Wij bieden
              kwalitatieve rijlessen met een hoge slagingskans en persoonlijke
              begeleiding.
            </p>
            <div className="flex space-x-4">{/* Social Links */}</div>

            <div className="mt-8">
              <h3 className="text-white font-bold text-sm mb-4 uppercase tracking-wider">
                Download onze leerlingen app
              </h3>
              <div className="flex flex-row items-center gap-3">
                <a
                  href="https://apps.apple.com/nl/app/on-my-way/id6670307079"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block transition-transform hover:scale-105"
                  aria-label="Download On My Way app in de App Store"
                >
                  <img
                    src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/nl-nl"
                    alt="Download in de App Store"
                    width={120}
                    height={40}
                    loading="lazy"
                    className="h-[40px] w-auto block"
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=nl.plango.omw&hl=nl&gl=US"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block transition-transform hover:scale-105"
                  aria-label="Download On My Way app in Google Play"
                >
                  <img
                    src="https://play.google.com/intl/en_us/badges/static/images/badges/nl_badge_web_generic.png"
                    alt="Ontdek het op Google Play"
                    width={150}
                    height={58}
                    loading="lazy"
                    className="h-[58px] max-w-none w-auto block"
                    style={{
                      clipPath: "inset(9px 11px 9px 11px)",
                      margin: "-9px -11px",
                    }}
                  />
                </a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-6">
              Waar rijden wij
            </h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>
                <Link
                  to="/rijschool-alphen-aan-den-rijn"
                  className="hover:text-primary transition-colors"
                  title="Rijschool Alphen aan den Rijn"
                >
                  Rijschool Alphen aan den Rijn
                </Link>
              </li>
              <li>
                <Link
                  to="/rijschool-ter-aar"
                  className="hover:text-primary transition-colors"
                  title="Rijschool Ter Aar"
                >
                  Rijschool Ter Aar
                </Link>
              </li>
              <li>
                <Link
                  to="/rijschool-boskoop"
                  className="hover:text-primary transition-colors"
                  title="Rijschool Boskoop"
                >
                  Rijschool Boskoop
                </Link>
              </li>
              <li>
                <Link
                  to="/rijschool-nieuwkoop"
                  className="hover:text-primary transition-colors"
                  title="Rijschool Nieuwkoop"
                >
                  Rijschool Nieuwkoop
                </Link>
              </li>
              <li>
                <Link
                  to="/rijschool-aarlanderveen"
                  className="hover:text-primary transition-colors"
                  title="Rijschool Aarlanderveen"
                >
                  Rijschool Aarlanderveen
                </Link>
              </li>
              <li>
                <Link
                  to="/rijschool-zevenhoven"
                  className="hover:text-primary transition-colors"
                  title="Rijschool Zevenhoven"
                >
                  Rijschool Zevenhoven
                </Link>
              </li>
              <li>
                <Link
                  to="/rijschool-hazerswoude-rijndijk"
                  className="hover:text-primary transition-colors"
                  title="Rijschool Hazerswoude-Rijndijk"
                >
                  Rijschool Hazerswoude-Rijndijk
                </Link>
              </li>
              <li>
                <Link
                  to="/rijschool-hazerswoude-dorp"
                  className="hover:text-primary transition-colors"
                  title="Rijschool Hazerswoude-Dorp"
                >
                  Rijschool Hazerswoude-Dorp
                </Link>
              </li>
              <li>
                <Link
                  to="/rijschool-woubrugge"
                  className="hover:text-primary transition-colors"
                  title="Rijschool Woubrugge"
                >
                  Rijschool Woubrugge
                </Link>
              </li>
              <li>
                <Link
                  to="/rijschool-langeraar"
                  className="hover:text-primary transition-colors"
                  title="Rijschool Langeraar"
                >
                  Rijschool Langeraar
                </Link>
              </li>
              <li>
                <Link
                  to="/rijschool-koudekerk-aan-den-rijn"
                  className="hover:text-primary transition-colors"
                  title="Rijschool Koudekerk a/d Rijn"
                >
                  Rijschool Koudekerk a/d Rijn
                </Link>
              </li>
              <li>
                <Link
                  to="/rijschool-zwammerdam"
                  className="hover:text-primary transition-colors"
                  title="Rijschool Zwammerdam"
                >
                  Rijschool Zwammerdam
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-6">Snel naar</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>
                <Link
                  to="/proefles"
                  className="hover:text-primary transition-colors"
                  title="Proefles Aanvragen"
                >
                  Proefles Aanvragen
                </Link>
              </li>
              <li>
                <Link
                  to="/rijlespakketten"
                  className="hover:text-primary transition-colors"
                  title="Rijlespakketten"
                >
                  Rijlespakketten
                </Link>
              </li>
              <li>
                <Link
                  to="/theorie"
                  className="hover:text-primary transition-colors"
                  title="Theorie"
                >
                  Theorie
                </Link>
              </li>
              <li>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    window.dispatchEvent(new Event("open-lead-capture"));
                  }}
                  className="hover:text-primary transition-colors text-left"
                  title="Theorie Cheat Sheet"
                >
                  Theorie Cheat Sheet
                </button>
              </li>
              <li>
                <Link
                  to="/over-ons"
                  className="hover:text-primary transition-colors"
                  title="Over Ons"
                >
                  Over Ons
                </Link>
              </li>
              <li>
                <Link
                  to="/vestiging"
                  className="hover:text-primary transition-colors"
                  title="Vestiging"
                >
                  Vestiging
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="hover:text-primary transition-colors"
                  title="FAQ"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="hover:text-primary transition-colors"
                  title="Blog"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="hover:text-primary transition-colors"
                  title="Contact"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-6">Onze Diensten</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>
                <Link
                  to="/rijles-met-adhd-autisme-alphen-aan-den-rijn"
                  className="hover:text-primary transition-colors"
                  title="ADHD / Autisme Rijles"
                >
                  ADHD / Autisme Rijles
                </Link>
              </li>
              <li>
                <Link
                  to="/rijangst-begeleiding-alphen-aan-den-rijn"
                  className="hover:text-primary transition-colors"
                  title="Rijangst Begeleiding"
                >
                  Rijangst Begeleiding
                </Link>
              </li>
              <li>
                <Link
                  to="/opfriscursus-autorijden"
                  className="hover:text-primary transition-colors"
                  title="Opfriscursus"
                >
                  Opfriscursus
                </Link>
              </li>
              <li>
                <Link
                  to="/spoedcursus-rijbewijs-alphen-aan-den-rijn"
                  className="hover:text-primary transition-colors"
                  title="Spoedcursus"
                >
                  Spoedcursus
                </Link>
              </li>
              <li>
                <Link
                  to="/2todrive-rijles-vanaf-16-5-jaar"
                  className="hover:text-primary transition-colors"
                  title="2toDrive (vanaf 16,5)"
                >
                  2toDrive (vanaf 16,5)
                </Link>
              </li>
              <li>
                <Link
                  to="/overstappen-van-rijschool"
                  className="hover:text-primary transition-colors"
                  title="Overstappen"
                >
                  Overstappen
                </Link>
              </li>
              <li>
                <Link
                  to="/informatie-voor-ouders"
                  className="hover:text-primary transition-colors"
                  title="Voor Ouders"
                >
                  Voor Ouders
                </Link>
              </li>
              <li>
                <Link
                  to="/tarieven"
                  className="hover:text-primary transition-colors"
                  title="Tarieven"
                >
                  Tarieven
                </Link>
              </li>
              <li>
                <Link
                  to="/vestiging"
                  className="hover:text-primary transition-colors"
                  title="VintedGo & Printservice"
                >
                  VintedGo & Printservice
                </Link>
              </li>
              <li>
                <Link
                  to="/printen"
                  className="hover:text-primary transition-colors"
                  title="Online Printen"
                >
                  Printen
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-6">
              Bedrijfsgegevens
            </h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>Adres: Stationsstraat 46</li>
              <li>2405BN Alphen aan den Rijn</li>
              <li>Rijschoolnummer: 1307F0</li>
              <li>KVK: 74192450</li>
              <li>BTW: NL002320535B37</li>
              <li>IBAN: NL59 RABO 0346 8290 89</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-6">
              Contact & Tijden
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <span>
                  Alphen aan den Rijn
                  <br />
                  en omgeving
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <div>
                  <a
                    href="tel:0172700509"
                    className="hover:text-white transition-colors block"
                  >
                    0172 - 700 509
                  </a>
                  <p className="text-xs text-slate-500 mt-0.5">
                    Telefonisch bereikbaar ma - vr 10:00 - 19:00
                  </p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-primary shrink-0" />
                <a
                  href="mailto:info@rijschooldediamant.nl"
                  className="hover:text-white transition-colors break-all"
                >
                  info@rijschooldediamant.nl
                </a>
              </li>
              <li className="flex items-start gap-3 pt-2">
                <Clock className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <div className="text-sm text-slate-400">
                  <p>
                    <strong className="text-white">Lestijden:</strong>
                    <br />
                    ma - zo 07:00 - 22:00
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3 pt-2">
                <Store className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <div className="text-sm text-slate-400">
                  <p>
                    <strong className="text-white">
                      Openingstijden vestiging:
                    </strong>
                    <br />
                    ma - za 07:00 - 21:00
                    <br />
                    zo 12:00 - 21:00
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500">
          <p className="text-center md:text-left flex-1">
            &copy; {new Date().getFullYear()} Rijschool De Diamant. Alle rechten
            voorbehouden.
          </p>
          <p className="text-center flex-1">
            Gemaakt door{" "}
            <a
              href="https://www.cloudschaap.nl"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-white transition-colors underline decoration-slate-700 underline-offset-4"
              aria-label="Website van Cloudschaap"
            >
              Cloudschaap
            </a>
          </p>
          <div className="flex gap-4 flex-1 justify-center md:justify-end">
            <Link to="/privacy" className="hover:text-white transition-colors">
              Privacyverklaring
            </Link>
            <Link
              to="/voorwaarden"
              className="hover:text-white transition-colors"
            >
              Algemene Voorwaarden
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
